import React, { useEffect, useState } from "react";
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Resize,
  Sort,
  ContextMenu,
  Filter,
  Page,
  ExcelExport,
  PdfExport,
  Edit,
  Inject,
} from "@syncfusion/ej2-react-grids";
import axios from "axios";
import { contextMenuItems, ordersGrid } from "../data/dummy";
import { Header } from "../components";
import { baseUrl } from "../data/baseURL";
import { format } from "date-fns-jalali";

const Modal = ({ isOpen, onClose, data }) => {
  
  const [isLoading, setIsLoading] = useState(false)
  const [states, setStates] = useState([])
  
  async function toggleStatus() {
    const token = localStorage.getItem("token");
    setIsLoading(true)
    if (data.isRead) {
      await axios.put(`${baseUrl}/Forms/ReadForm`, {}, {
        params: {
          id: data.id,
          isRead: false
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }).then(r=>{
        data.isRead = false
      })
    } else {
      await axios.put(`${baseUrl}/Forms/ReadForm`, {}, {
        params: {
          id: data.id,
          isRead: true
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }).then(r=>{
        data.isRead = true
      })
    }
    setIsLoading(false)
  }

  const loadStates = async () => {
    let s = await axios.get(`${baseUrl}/states`)
    setStates(s.data.data);
  }

  useEffect(()=>{
    loadStates()
  }, [])

  if (!isOpen) return null;

  return (
    <div style={modalBackdropStyles}>
      <div style={modalStyles}>
        <div style={modalHeaderStyles}>
          <h3 style={modalTitleStyles}>جزئیات فرم شماره {data.id}</h3>
          <button onClick={onClose} style={modalCloseButtonStyles}>
            &times;
          </button>
        </div>
        <div style={modalContentStyles}>
          <form style={formStyles}>
            <h3 style={sectionTitleStyles}>اطلاعات هویتی</h3>
            <div style={formGroupStyles}>
              <label style={labelStyles} htmlFor="first-name">
                نام:
              </label>
              <input
                style={inputStyles}
                type="text"
                id="first-name"
                name="first-name"
                value={data.firstName}
                disabled
              />
            </div>
            <div style={formGroupStyles}>
              <label style={labelStyles} htmlFor="last-name">
                نام خانوادگی:
              </label>
              <input
                style={inputStyles}
                type="text"
                id="last-name"
                name="last-name"
                value={data.lastName}
                disabled
              />
            </div>
            <div style={formGroupStyles}>
              <label style={labelStyles} htmlFor="birth-date">
                تاریخ تولد:
              </label>
              <input
                style={inputStyles}
                type="text"
                id="birth-date"
                name="birth-date"
                value={data.birthDate}
                disabled
              />
            </div>
            <div style={formGroupStyles}>
              <label style={labelStyles} htmlFor="father-name">
                نام پدر:
              </label>
              <input
                style={inputStyles}
                type="text"
                id="father-name"
                name="father-name"
                value={data.fatherName}
                disabled
              />
            </div>
            <div style={formGroupStyles}>
              <label style={labelStyles} htmlFor="national-code">
                کدملی:
              </label>
              <input
                style={inputStyles}
                type="text"
                id="national-code"
                name="national-code"
                value={data.nationalCode}
                disabled
              />
            </div>
            <div style={formGroupStyles}>
              <label style={labelStyles} htmlFor="province">
                استان محل سکونت:
              </label>
              <select
                style={inputStyles}
                id="province"
                name="province"
                value={data.state ? data.state : ""}
                disabled
              >
                <option value="" disabled>
                  {states ? "انتخاب نشده" : "در حال بارگیری..."}
                </option>
                {
                  states && states.map((state)=>{
                    return (<option value={state.name} key={state.id}>{state.name}</option>)
                  })
                }
              </select>
            </div>
            <div style={formGroupStyles}>
              <label style={labelStyles} htmlFor="city">
                شهر محل سکونت:
              </label>
              <select
                style={inputStyles}
                id="city"
                name="city"
                value={data.city ? data.city : ""}
                disabled
              >
                <option value="" disabled>
                  {states ? "انتخاب نشده" : "در حال بارگیری..."}
                </option>
                {
                  states && states.map((state)=>{
                    return (<>
                      {
                        state.cities.map((city)=>{
                          return (<option value={city.name} key={city.id}>{city.name}</option>)
                        })
                      }
                    </>)
                  })
                }
              </select>
            </div>
            <div style={formGroupStyles}>
              <label style={labelStyles} htmlFor="religion">
                دین و مذهب:
              </label>
              <input
                style={inputStyles}
                type="text"
                id="religion"
                name="religion"
                value={data.religion}
                disabled
              />
            </div>
            <div style={formGroupStyles}>
              <label style={labelStyles} htmlFor="marital-status">
                وضعیت تاهل:
              </label>
              <input
                style={inputStyles}
                type="text"
                id="marital-status"
                name="marital-status"
                value={data.maritalStatus}
                disabled
              />
            </div>
            <div style={formGroupStyles}>
              <label style={labelStyles} htmlFor="education">
                میزان تحصیلات / رشته تحصیلی:
              </label>
              <input
                style={inputStyles}
                type="text"
                id="education"
                name="education"
                value={data.studyStatus}
                disabled
              />
            </div>
            <div style={formGroupStyles}>
              <label style={labelStyles} htmlFor="job">
                شغل و پیشه:
              </label>
              <input
                style={inputStyles}
                type="text"
                id="job"
                name="job"
                value={data.job}
                disabled
              />
            </div>
            <div style={formGroupStyles}>
              <label style={labelStyles} htmlFor="relative-contact">
                شماره تماس نزدیکان:
              </label>
              <input
                style={inputStyles}
                type="text"
                id="relative-contact"
                name="relative-contact"
                value={data.familyPhoneNumber}
                disabled
              />
            </div>
            <div style={formGroupStyles}>
              <label style={labelStyles} htmlFor="mobile-number">
                شماره همراه:
              </label>
              <input
                style={inputStyles}
                type="text"
                id="mobile-number"
                name="mobile-number"
                value={data.phoneNumber}
                disabled
              />
            </div>

            <div style={formGroupStyles}>
              <label style={labelStyles} htmlFor="language-knowledge">
                <input
                  type="checkbox"
                  id="language-knowledge"
                  name="language-knowledge"
                  checked={data.knownLanguages}
                  disabled
                />
                آشنایی با زبان و گویش خاص
              </label>
            </div>
            <div style={formGroupStyles}>
              <textarea
                style={textAreaStyles}
                id="language-knowledge-details"
                name="language-knowledge-details"
                placeholder="جزئیات"
                value={data.knownLanguages}
                disabled
              ></textarea>
            </div>
            <hr style={dividerStyles} />
            <h3 style={sectionTitleStyles}>اطلاعات همکاری</h3>
            <div style={formGroupStyles}>
              <label style={labelStyles}>بازه همکاری:</label>
              <div>
                <label>
                  <input
                    type="radio"
                    name="collaboration-time"
                    value="16 تا 25 مرداد 1403"
                    checked={data.helpTimeRange.includes("16-25 مرداد 1403")}
                    disabled
                  />{" "}
                  16 تا 25 مرداد 1403
                </label>
                <label>
                  <input
                    type="radio"
                    name="mosque-type"
                    value="22 تا 30 مرداد 1403"
                    checked={data.helpTimeRange.includes("22-30 مرداد 1403")}
                    disabled
                  />{" "}
                  22 تا 30 مرداد 1403
                </label>
              </div>
            </div>

            <div style={formGroupStyles}>
              <label style={labelStyles} htmlFor="address">
                چه کاری برای زائرین امام حسین از دستتون برمیاد؟
              </label>
              <textarea
                style={textAreaStyles}
                id="Details"
                name="Details"
                  value={data.questionAnswer}
                disabled
              ></textarea>
            </div>
          </form>
        </div>
        <div style={modalFooterStyles}>
          <button onClick={toggleStatus} style={{...buttonStyles, backgroundColor: isLoading ? "gray" : "rgb(3, 201, 215)"}} disabled={isLoading}>{data.isRead ? "تغییر وضعیت به بررسی نشده" : "تغییر وضعیت به بررسی شده"}</button>
          {isLoading && "در حال تغییر وضعیت..."}
        </div>
      </div>
    </div>
  );
};

// Modal Styles
const modalBackdropStyles = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 1000,
};

const modalStyles = {
  backgroundColor: "#fff",
  borderRadius: "8px",
  width: "80%",
  maxWidth: "700px",
  padding: "20px",
  position: "relative",
  boxShadow: "0 5px 15px rgba(0, 0, 0, 0.3)",
};

const modalHeaderStyles = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  borderBottom: "1px solid #e0e0e0",
  paddingBottom: "10px",
};

const modalFooterStyles = {
  display: "flex",
  gap: "20px",
  alignItems: "center",
  borderTop: "1px solid #e0e0e0",
  paddingTop: "20px",
  color: "gray"
};

const modalTitleStyles = {
  margin: 0,
  fontSize: "20px",
  fontWeight: "bold",
};

const modalCloseButtonStyles = {
  background: "none",
  border: "none",
  fontSize: "24px",
  cursor: "pointer",
  padding: "0 10px"
};

const modalContentStyles = {
  maxHeight: "70vh",
  overflowY: "auto",
  padding: "20px 0"
};

const formStyles = {
  display: "flex",
  flexDirection: "column",
  gap: "15px",
};

const sectionTitleStyles = {
  fontSize: "18px",
  fontWeight: "bold",
  borderBottom: "1px solid #e0e0e0",
  paddingBottom: "5px",
  marginBottom: "10px",
};

const formGroupStyles = {
  display: "flex",
  flexDirection: "column",
  gap: "5px",
};

const labelStyles = {
  fontSize: "14px",
  fontWeight: "bold",
};

const inputStyles = {
  padding: "10px",
  borderRadius: "4px",
  border: "1px solid #ccc",
  fontSize: "14px",
  width: "100%",
  WebkitAppearance: "none",
  MozAppearance: "none"
};

const textAreaStyles = {
  padding: "10px",
  borderRadius: "4px",
  border: "1px solid #ccc",
  fontSize: "14px",
  width: "100%",
  minHeight: "80px",
};

const dividerStyles = {
  margin: "20px 0",
  border: "none",
  borderBottom: "1px solid #e0e0e0",
};

const buttonStyles = {
  backgroundColor: "rgb(3, 201, 215)",
  color: "white",
  padding: "10px 20px",
  borderRadius: "5px"
}

const Hossein = () => {
  const [ordersData, setOrdersData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);

  const editing = { allowDeleting: true, allowEditing: true };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${baseUrl}/Forms/Forms`, {
          params: {
            formType: 1,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        let data = []
        if(response) {
          response.data.data.forEach(post => {
            data.push({
              ...post,
              createdAt: format(new Date(post.createdAt * 1000), "d MMMM yyyy")
            })
          })
        }
        setOrdersData(data);
      } catch (error) {
        console.error("Error fetching data from API", error);
      }
    };
    fetchData();
  }, []);

  const handleRowClick = async (row) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(`${baseUrl}/Forms/Form`, {
        params: {
          id: row.id,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setSelectedRowData(response.data.data);
      setIsModalOpen(true);
    } catch (error) {
      console.error("Error fetching row details", error);
    }
  };

  return (
    <div className="m-2 md:m-10 mt-24 p-2 md:p-10 bg-white rounded-3xl">
      <Header category="Page" title="فرم پای کار حسین" />
      <GridComponent
        id="gridcomp"
        dataSource={ordersData}
        allowPaging
        allowSorting
        allowExcelExport
        allowPdfExport
        contextMenuItems={contextMenuItems}
        rowSelected={(args) => handleRowClick(args.data)}
      >
        <ColumnsDirective>
          {ordersGrid.map((item, index) => (
            <ColumnDirective key={index} {...item} />
          ))}
        </ColumnsDirective>
        <Inject
          services={[
            Resize,
            Sort,
            ContextMenu,
            Filter,
            Page,
            ExcelExport,
            Edit,
            PdfExport,
          ]}
        />
      </GridComponent>{" "}
      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        data={selectedRowData}
      />
    </div>
  );
};

export default Hossein;
